import React from 'react';

import { CommodityCreateDetails } from '@components/utilities/Commodity/CommodityCreateDetails';
import { useSearch } from '@hooks/next/useSearch';
import { CommodityActionStatus } from '@models/next/Commodity';
import { z } from 'zod';

export const CommodityDetails: React.FC = () => {
  const { search } = useSearch(
    z.object({
      id: z.number(),
      action: CommodityActionStatus.optional(),
    }),
  );

  return <CommodityCreateDetails type="details" id={search.id} action={search.action} />;
};
